import {
  CURRENCY_VS_SYMBOL_MAP,
  SerializedOutstandingSAFEs,
  formatNumberWithUniqueCommaPattern,
} from '@commenda/utils';
import { Currency, File } from '@prisma/client';
import { TfiDownload } from 'react-icons/tfi';
import { FileDownloaderWrapper } from '../../../components';

const OutstandingSAFEsTable = ({
  outstandingSAFEs,
  currency,
  token,
}: {
  outstandingSAFEs: SerializedOutstandingSAFEs[];
  currency: Currency;
  token: string | undefined;
}) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flow-root w-full">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      className="py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Investor Name
                    </th>

                    <th
                      scope="col"
                      className="py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Investor Email Address
                    </th>
                    <th
                      scope="col"
                      className="py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Investment Amount
                    </th>
                    <th
                      scope="col"
                      className="py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Post Money Valuation
                    </th>
                    <th
                      scope="col"
                      className="py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Signee Director
                    </th>
                    <th
                      scope="col"
                      className="py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Download SAFE Note
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {outstandingSAFEs?.map((outstandingSAFE) => (
                    <tr key={outstandingSAFE?.id}>
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                        {outstandingSAFE?.date}
                      </td>
                      <td className="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900">
                        {outstandingSAFE?.investorName}
                      </td>
                      <td className="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900">
                        {outstandingSAFE?.investorEmail}
                      </td>
                      <td className="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900">
                        {CURRENCY_VS_SYMBOL_MAP[currency]}
                        {formatNumberWithUniqueCommaPattern(
                          outstandingSAFE?.investmentAmount,
                          2
                        )}
                      </td>
                      <td className="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900">
                        {CURRENCY_VS_SYMBOL_MAP[currency]}
                        {formatNumberWithUniqueCommaPattern(
                          outstandingSAFE?.postMoneyValuation,
                          2
                        )}
                      </td>
                      <td className="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900">
                        {outstandingSAFE?.signeeDirector}
                      </td>
                      <td className="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900">
                        <FileDownloaderWrapper
                          token={token}
                          file={outstandingSAFE?.file as unknown as File}
                        >
                          <TfiDownload className="cursor-pointer text-xl text-gray-400 hover:text-gray-900 transition-colors" />
                        </FileDownloaderWrapper>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutstandingSAFEsTable;
